// extracted by mini-css-extract-plugin
export default {"WordResume":"styles_WordResume__EQhZZ"};